// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1j38B","info":"UpdateTermsInfo_info__4lzxV"};